export default "<div class=\"country\">\n    {{PaysInComponent?.Nom}}\n</div>";